import * as React from "react";
import { DirectionalHint, ITooltipHostStyles, TooltipHost } from "@fluentui/react";
import authModule from "../../../../../../utilities/AuthModule";
import { fetchWithRetry } from "../../../../../../utilities/FetchRetryUtil";

const inlineFlexTooltipHost: ITooltipHostStyles = {
    root: {
        display: "inline-flex"
    }
}

interface IImageRenderProps {
    imageName: string;
    imageItemUrl: string;
}

export const ImageRenderer: React.FC<IImageRenderProps> = (props) => {
    const [imageUrl, setImageUrl] = React.useState<string>();

    React.useEffect(() => {
        getImageUrl(props.imageItemUrl);
    }, [props.imageItemUrl, setImageUrl]);

    const getImageUrl = async (imageItemUrl: string): Promise<void> => {
        try {
            const response: Response = await fetchWithRetry(imageItemUrl + "/thumbnails/0/c48x48/content", {
                headers: {
                    "Authorization": `Bearer ${await authModule.getSharePointAccessToken()}`
                }
            });

            if (response.ok) {
                const url = window.URL || window.webkitURL;
                const blob = await response.blob();
                setImageUrl(url.createObjectURL(blob));
            }
        } catch (err) {
            // Ignore
        }
    }

    return !imageUrl
        ? <></>
        : <TooltipHost content={props.imageName} styles={inlineFlexTooltipHost} directionalHint={DirectionalHint.topAutoEdge}>
            <img alt={props.imageName} src={imageUrl} />
        </TooltipHost>
}